const semanticClassNames = {
  root: 'hamburger-overlay',
} as const;

export default semanticClassNames;
